import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'byActive',
  pure: false,
  standalone: false
})
export class ByActivePipe implements PipeTransform {
  public transform(items: any[], isActive: boolean): any[] {
    return items.filter((item) => {
      return item.IsActive === isActive;
    });
  }
}
